export const LOCATIONS_QUERY = "getLocations";
